import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { hideScrollbar } from '../../../../../play-core/styles/style-helper';
import { Viewports } from '../../../../../play-core/styles/Viewports';
import { Chip } from '../../../components/Chip/Chip';
import { PlayContainer } from '../../../components/PlayContainer/PlayContainer';
import { usePersonalizationSettings } from '../../../providers/DataProvider/DataContext';
import { searchBarSideMargin } from '../SearchBar/SearchBar.styles';
import { useSearchDispatch, useSearchState } from '../SearchContext';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SearchHistory = () => {
  const searchDispatch = useSearchDispatch();
  const {
    searchHistory
  } = useSearchState();
  const {
    isActive
  } = usePersonalizationSettings();
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsx(Fragment, {
    children: !!searchHistory.length && isActive && /*#__PURE__*/_jsx(PlayContainer, {
      children: /*#__PURE__*/_jsxs(StyledSearchHistory, {
        children: [/*#__PURE__*/_jsx(Chip, {
          showIcon: false,
          title: t('search.deleteSearchHistory'),
          id: 'clear-search-history',
          size: "regular",
          showBorder: false,
          onClick: () => searchDispatch({
            type: 'clear-search-history'
          })
        }), searchHistory.map(historyEntry => /*#__PURE__*/_jsx(Chip, {
          showIcon: false,
          title: historyEntry.searchTerm,
          id: historyEntry.searchTerm,
          size: "regular",
          onClick: () => {
            searchDispatch({
              type: 'search',
              query: historyEntry.searchTerm
            });
            searchDispatch({
              type: 'include-aggregations'
            });
          }
        }, historyEntry.searchTerm))]
      })
    })
  });
};
const StyledSearchHistory = styled.section.withConfig({
  displayName: "SearchHistory__StyledSearchHistory",
  componentId: "sc-mxetxv-0"
})(["display:flex;overflow:scroll auto;white-space:nowrap;margin-top:28px;", "{padding-top:15px;}", "{margin-left:", "px;margin-right:", "px;}", ";"], Viewports.for('small'), Viewports.for('mediumUp'), searchBarSideMargin, searchBarSideMargin, hideScrollbar());